import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import {Control, Form} from 'react-redux-form';
import {Modal, OverlayTrigger, Tooltip} from 'react-bootstrap';

import duckify from '../../utils/duckify';
import { activityItems, activityItemsForm, modals } from '../../ducks';
import PageHeader from "../PageHeader";
import ControlGroup from "../forms/ControlGroup";
import ValidationErrors from '../forms/ValidationErrors';
import ModalRoot from "../ModalRoot";

import './styles/ActivityItemsList.scss';
import ManagedResourceList from '../shared/ManagedResourceList';

const mapStateToModalProps = (state) => ({
  ...state.activityItemsForm
});

const mapDispatchToModalProps = (dispatch) => ({
  updateItem:
    (item) => dispatch(activityItemsForm.actions.save(item))
      .then(() => dispatch(modals.actions.hide('EditActivityItemModal')))
});

const EditActivityItemModal =
  connect(mapStateToModalProps, mapDispatchToModalProps)(
    ({updateItem, model, hideModal}) =>
      <Modal show className="activity-items-list-edit-modal" backdrop='static' keyboard={false}>
        <Modal.Header>
          <h1 className='modal-title' style={{display: 'inline-block'}}>Edit Activity Item</h1>
          <button type='button' className='btn-close' aria-label='Close' onClick={hideModal} />
        </Modal.Header>
        <Modal.Body>
          <Form model='activityItemsForm.model' className='form-horizontal'>
            <ValidationErrors errors={model.errors}/>

            <ControlGroup label='Name'>
              <Control.text model='.name'/>
            </ControlGroup>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-light' onClick={hideModal}>Close</button>
          <button className='btn btn-primary' onClick={() => updateItem(model)}>Submit</button>
        </Modal.Footer>
      </Modal>
  );

class ActivityItemList extends React.Component {
  static propTypes = {
    activityItems: PropTypes.array,
    activityItemsForm: PropTypes.object,

    deactivateItem: PropTypes.func,
    fetchItems: PropTypes.func,
    editItem: PropTypes.func,
    reactivateItem: PropTypes.func
  };

  static defaultProps = {
    activityItems: [],
    activityItemsForm: {},

    deactivateItem: () => false,
    fetchItems: () => false,
    editItem: () => false,
    reactivateItem: () => false
  };

  constructor() {
    super();

    this.state = {
      showInactive: false
    }
  }

  toggleInactive() {
    this.setState({
      showInactive: !!!this.state.showInactive
    });
  }

  render() {
    const {
      activityItems,
      deactivateItem,
      fetchItems,
      editItem,
      reactivateItem
    } = this.props;

    const activeItems = activityItems.filter((item) => item.state === 'active');
    const inactiveItems = activityItems.filter((item) => item.state === 'inactive');

    return <div>
      <PageHeader header='Activity Items'/>

      <ModalRoot modals={{EditActivityItemModal}}/>

      <ManagedResourceList
        deleteItem={deactivateItem}
        fetchItems={fetchItems}
        items={activeItems}
        itemButtons={[
          ({item}) =>
            !item.standard
              ? <button className='btn btn-xs btn-primary' onClick={() => editItem(item)}>
                <FontAwesome name='pencil'/>
              </button>
              : null,
          ({deleteItem, item}) =>
            !item.standard
              ? <button className='btn btn-xs btn-danger' onClick={deleteItem}>
                <FontAwesome name='times'/>
              </button>
              : null
        ]}
        displayType='activity item'
        collectionButtons={
          [
            () =>
              <a className='add-item-button' onClick={() => editItem({name: ''})}>
                <FontAwesome name='plus-circle'/> Add a new Activity Item
              </a>
          ]
        }
        emptyListMessage={'Sorry, there are no activity items configured.'}
        columns={[
          {
            header: 'Name',
            value: (item) => item.name
          },
          {
            header: <span>
              System Name&nbsp;
              <OverlayTrigger overlay={<Tooltip>The System Name is used behind the scenes by the system and cannot be edited.</Tooltip>}>
                <FontAwesome name='info-circle'/>
              </OverlayTrigger>
            </span>,
            value: (item) => item.canonical_name
          },
          {
            header: <span>
              Type&nbsp;
              <OverlayTrigger overlay={<Tooltip>System Activities are default activities in the system and cannot be made inactive.</Tooltip>}>
                <FontAwesome name='info-circle'/>
              </OverlayTrigger>
            </span>,
            value: (item) => item.standard ? 'Standard' : 'Custom'
          }
        ]}
        tableClassName='table-striped activity-items-list'
      />

      {
        !!inactiveItems.length && <button className='btn btn-primary btn-sm' onClick={() => this.toggleInactive()}>
          Removed Activity Items&nbsp;
          {
            this.state.showInactive
              ? <FontAwesome name='chevron-down'/>
              : <FontAwesome name='chevron-right'/>
          }
        </button>
      }

      {
        !!inactiveItems.length && this.state.showInactive && <div>
          <ManagedResourceList
            fetchItems={fetchItems}
            items={inactiveItems}
            itemButtons={[
              ({item}) =>
                <button className='btn btn-sm btn-success' onClick={() => reactivateItem(item)}>
                  <FontAwesome name='rotate-right'/>
                </button>
            ]}
            displayType='activity item'
            emptyListMessage={'Sorry, there are no activity items configured.'}
            collectionButtons={[]}
            columns={[
              {
                header: 'Name',
                value: (item) => item.name
              },
              {
                header: <span>
                  System Name&nbsp;
                      <OverlayTrigger overlay={<Tooltip>The System Name is used behind the scenes by the system and cannot be edited.</Tooltip>}>
                    <FontAwesome name='info-circle'/>
                  </OverlayTrigger>
                </span>,
                value: (item) => item.canonical_name
              },
              {
                header: <span>
                  Type&nbsp;
                      <OverlayTrigger overlay={<Tooltip>System Activities are default activities in the system and cannot be made inactive.</Tooltip>}>
                    <FontAwesome name='info-circle'/>
                  </OverlayTrigger>
                </span>,
                value: (item) => item.standard ? 'Standard' : 'Custom'
              }
            ]}
            tableClassName='table-striped activity-items-list activity-items-list-inactive'
          />
        </div>
      }
    </div>
  }
}


const mapDucksToProps = () => ({
  activityItems,
});

const mapDispatchToProps = (dispatch, props) => ({
  deactivateItem: (item) => dispatch(
    activityItems.actions.remove(item)
  ),
  fetchItems: () => dispatch(
    activityItems.actions.load()
  ),
  editItem: (item) => {
    dispatch(
      activityItemsForm.actions.load(item)
    );

    dispatch(
      modals.actions.show('EditActivityItemModal', {
        hideModal: () => dispatch(modals.actions.hide('EditActivityItemModal'))
      })
    )
  },
  reactivateItem: (item) => {
    item.state = 'active';

    return dispatch(
      activityItems.actions.update(item)
    );
  }
});

export default duckify(mapDucksToProps, () => ({}), mapDispatchToProps)(ActivityItemList);
